// extracted by css-extract-rspack-plugin
export default {"container":"vqJqcSW___container"};